const Spacer = () => (
  <div
    style={{
      flexGrow: 1,
    }}
  />
);

export default Spacer;
